import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";
import { Pagination } from "services/search";
import { DataWithPagination } from "services/api/types";

import {
  transformUsageEvent,
  transformUsageEventRow,
  transformUsageSummary,
} from "./transformations";
import { UsageEvent, UsageEventRow, UsageSearchFormValues, UsageSummary } from "./types";

/** Filtri se slažu jednom, jer ih dijele popis i zbroj razdoblja. */
const buildFilterQuery = (filters?: UsageSearchFormValues): string => {
  let query = "";

  if (filters?.search) query += `search=${encodeURIComponent(filters.search)}&`;
  if (filters?.pricingKeyCode) query += `pricingKeyCode=${encodeURIComponent(filters.pricingKeyCode)}&`;
  if (filters?.userId) query += `userId=${filters.userId}&`;
  if (filters?.isSuccess) query += `isSuccess=${filters.isSuccess}&`;
  if (filters?.dateFrom) query += `dateFrom=${filters.dateFrom.toISOString()}&`;
  if (filters?.dateTo) query += `dateTo=${filters.dateTo.toISOString()}&`;

  return query;
};

export const getUsageEventsAPI = async (
  pagination: Pagination,
  filters?: UsageSearchFormValues
): Promise<DataWithPagination<UsageEventRow>> => {
  const path = `/v1/finance/usage?${buildFilterQuery(filters)}`;

  return await paginatedApiCall(path, pagination, transformUsageEventRow);
};

export const getUsageEventAPI = async (id: string): Promise<UsageEvent> => {
  const response = await createApiCall(
    {
      path: `/v1/finance/usage/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformUsageEvent(response.data);
};

/** Koliko je događaja i koliko je naplaćeno u istom obuhvatu koji popis pokazuje. */
export const getUsageSummaryAPI = async (
  filters?: UsageSearchFormValues
): Promise<UsageSummary> => {
  const response = await createApiCall(
    {
      path: `/v1/finance/usage/summary?${buildFilterQuery(filters)}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformUsageSummary(response.data);
};
